import { render } from "./App.vue?vue&type=template&id=bdce8a3a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bdce8a3a&lang=css"

import exportComponent from "/home/greg/code/avxcwx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__